import { render, staticRenderFns } from "./setAnjakanGaji.vue?vue&type=template&id=ad0b636e&"
import script from "./setAnjakanGaji.vue?vue&type=script&lang=js&"
export * from "./setAnjakanGaji.vue?vue&type=script&lang=js&"
import style0 from "./setAnjakanGaji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports